import { ChecklistBuilder } from "features/pilot-tracking/checklists/ChecklistBuilder"
import { useCreateChecklist } from "features/pilot-tracking/checklists/ChecklistQueries"
import {
    resetChecklistChangeFlags,
    selectChecklistCreationDescription,
    selectChecklistCreationQuestions,
    selectChecklistCreationTitle,
    setChecklistCreationQuestions,
} from "features/pilot-tracking/checklists/slice"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { setGlobalNotificationContext } from "user/profile/slice"
import { GlobalNotificationStatus } from "@nova/component-global-notification"
import { useRouter } from "pages"
import { getGenericWorkspacePage, getGenericWorkspacePageHeader } from "../WorkspaceRoutes"
import { useCallback, useEffect } from "react"
import { ButtonPrimary } from "@nova/component-btn"
import * as Icons from "@nova/component-icons"
import { useChecklistUnsavedChangesBlocker } from "features/pilot-tracking/checklists/usePilotTrackingUnsavedChangesBlocker"

export const CreateChecklistPage = getGenericWorkspacePage({
    Header: getGenericWorkspacePageHeader({
        title: "Create Checklist",
        rightItems: [
            () => {
                const dispatch = useAppDispatch()
                const router = useRouter("/workspace/:workspaceId")
                const { createChecklist } = useCreateChecklist()
                const questions = useAppSelector(selectChecklistCreationQuestions)
                const name = useAppSelector(selectChecklistCreationTitle)
                const description = useAppSelector(selectChecklistCreationDescription)
                const handleCreateChecklist = useCallback(async () => {
                    if (!questions) return
                    await createChecklist({
                        name: name || "Untitled Checklist",
                        description,
                        form: questions,
                    })
                        .then(() => {
                            dispatch(resetChecklistChangeFlags())
                            dispatch(
                                setGlobalNotificationContext({
                                    message: "Checklist saved successfully.",
                                    status: GlobalNotificationStatus.success,
                                    timeoutInMs: 3000,
                                })
                            )
                            setTimeout(() => router.navigate({ path: "/fleet/checklists" }), 0)
                        })
                        .catch(() => {
                            dispatch(
                                setGlobalNotificationContext({
                                    message: "Failed to save checklist. Please try again.",
                                    status: GlobalNotificationStatus.error,
                                    timeoutInMs: 3000,
                                })
                            )
                        })
                }, [createChecklist, description, dispatch, name, questions, router])
                return (
                    <ButtonPrimary
                        title="Publish"
                        RightIcon={Icons.Upload}
                        onClick={handleCreateChecklist}
                    />
                )
            },
        ],
    }),
    Content: CreateChecklistPageContent,
    maxWidth: 1200,
})

function CreateChecklistPageContent() {
    useChecklistUnsavedChangesBlocker()
    const dispatch = useAppDispatch()
    const questions = useAppSelector(selectChecklistCreationQuestions)
    useEffect(() => {
        if (questions !== null) return
        dispatch(setChecklistCreationQuestions([]))
    }, [dispatch, questions])
    return <ChecklistBuilder />
}
